var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiltArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.438 5V13.125C16.438 13.3736 16.3392 13.6121 16.1634 13.7879C15.9876 13.9637 15.7491 14.0625 15.5005 14.0625C15.2518 14.0625 15.0134 13.9637 14.8375 13.7879C14.6617 13.6121 14.563 13.3736 14.563 13.125V7.26562L6.16374 15.6633C5.98762 15.8394 5.74874 15.9383 5.49967 15.9383C5.2506 15.9383 5.01173 15.8394 4.83561 15.6633C4.65949 15.4872 4.56055 15.2483 4.56055 14.9992C4.56055 14.7501 4.65949 14.5113 4.83561 14.3352L13.2348 5.9375H7.37545C7.12681 5.9375 6.88836 5.83873 6.71254 5.66291C6.53673 5.4871 6.43795 5.24864 6.43795 5C6.43795 4.75136 6.53673 4.5129 6.71254 4.33709C6.88836 4.16127 7.12681 4.0625 7.37545 4.0625H15.5005C15.7491 4.0625 15.9876 4.16127 16.1634 4.33709C16.3392 4.5129 16.438 4.75136 16.438 5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiltArrow);
export default __webpack_public_path__ + "static/media/tiltArrow.58e6ebdcd2ac0ce66bc6945993e65baa.svg";
export { ForwardRef as ReactComponent };